import { useStore } from '@nanostores/react'
import React, { useEffect, useState } from 'react'

import type { CMSRedemptionOptionGroup } from '@/types/sanity'
import { SimpleSelectableOption } from '../Shared/SimpleSelectableOption'
import { getInputType } from '@/scripts/program-panel/utilities'

import './RedemptionOptions.scss'
import { $isLoggedIn } from '@/stores/account/computed'
import { $customer } from '@/stores/account/stores'
import { captureException } from '@/utilities/logger-fe'
import { ExpandableCard } from '../Shared/ExpandableCard'

type Props = {
  config: CMSRedemptionOptionGroup
  onChange?: (amountToRedeem: number) => void
}

export const RedemptionOptions: React.FC<Props> = ({ config, onChange }) => {
  const [checked, setChecked] = useState(false)
  const [redemptionPoints, setRedemptionPoints] = useState(0)

  const isLoggedIn = useStore($isLoggedIn)
  const customer = useStore($customer)

  useEffect(() => {
    if (!isLoggedIn || !customer) return

    const fetchRedemptionPoints = async () => {
      try {
        const response = await fetch('/api/yotpo-loyalty', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: customer.email }),
        })
        const data = await response.json()
        setRedemptionPoints(data.points_balance)
      } catch (e) {
        captureException(e)
      }
    }

    fetchRedemptionPoints()
  }, [])

  if (!redemptionPoints || redemptionPoints < 1250) return null

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const _checked = e.target.checked
    setChecked(_checked)
    const amountToRedeem = _checked ? 75 : 0
    onChange && onChange(amountToRedeem)
  }

  const inputType = getInputType(config.optionGroupType)

  return (
    <div className="flexible-program-redemption-options">
      <ExpandableCard
        title={<span className="type-eyebrow">{config.label}</span>}
        isExpanded={config.isOpen}
      >
        <div className="flexible-program-redemption-options__body">
          {config.options.map((option) => (
            <SimpleSelectableOption
              id={option._id}
              name={config._id}
              value={option.label}
              disabled={option.disabled}
              type={inputType}
              key={option._id}
              label={option.label}
              checked={checked}
              styling="borderless"
              onChange={handleChange}
            />
          ))}
          {/* {checked && (
            <div className="flexible-program-redemption-options__disclaimer type-label">
              Success! Your $75 reward will be applied to your first
              subscription payment and reflected at checkout.
            </div>
          )} */}
        </div>
      </ExpandableCard>
    </div>
  )
}
